import { Injectable } from '@angular/core';
import { AnyHandler } from 'src/app/types/@types/sl-v-types';
import { Subject } from 'rxjs';

export interface MapPickerParams {
	handler: AnyHandler;
}

@Injectable({
	providedIn: 'root'
})
export class MapPickerDialogService {
	public request$: Subject<MapPickerParams> = new Subject();

	constructor() { }
	Show(
		handler: AnyHandler
	) {
		const params: MapPickerParams = {
			handler: (handler)
		};

		this.request$.next(params);
	}
}
